module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cart-white-a8f3274bd48baa2ce14515fb72ad696d.svg";